import React from 'react';
import { Alert, Spinner, Table, Container, Row, Col } from 'react-bootstrap';
import { Assets, PageStatus } from 'enums';
import { Show } from 'Layout';
import { SurveysAPI } from "../../API";
import { branding } from '../../config/portalBranding';
import GridContainer from "../Grid/GridContainer";
import { Grid } from "@material-ui/core";
import { formatDate } from "../../Utils/formatDate";



export default class SurveySpeederLimitTerminate extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            survey: null,
            status: PageStatus.None,
            error: null,
        };
    }

    componentDidMount() {
        const fullSltUrl = window.location.href;
        const querySltString = fullSltUrl.split('?')[1] || '';
        const urlSltSearchParams = new URLSearchParams(querySltString);
        const surveyId = urlSltSearchParams.get('surveyid');
        const userId = urlSltSearchParams.get('userid');
        if (!!surveyId && !!userId) {
            this.fetchSltSurvey(surveyId, userId);
        }
    }

    // Read-only fetch — the hit was already recorded by the DX (admin) layer
    // upstream. No status updates, no redirects on success; this page is terminal.
    fetchSltSurvey(surveyId, userId) {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => SurveysAPI.getSurveyDisplayData({ surveyId, userId }))
            .then((survey) => {
                this.setState({ survey, status: PageStatus.Loaded });
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }


    render() {
        return (
            <div style={{ background: '#f5f5f5', border: '2px solid #ddd', padding: '20px'}}>
                <GridContainer>
                    <Grid container justify="center" alignItems="center">
                        <Grid item>
                            <img
                                src={branding.logo || Assets.Logo2}
                                alt="Logo"
                                style={{ maxWidth: '100%', maxHeight: '100%' }}
                            />
                        </Grid>
                    </Grid>
                </GridContainer>
                <Show when={this.state.status === PageStatus.Loading}>
                    <Container className="d-flex justify-content-center mt-5">
                        <Spinner animation="border" variant="primary" />
                    </Container>
                </Show>

                    <Container className='text-center mt-5'>
                        <h1>Terminated due to speeder limit mismatch.</h1>
                    </Container>
                <Show when={this.state.status === PageStatus.Loaded && !!this.state.survey && this.state.survey.surveysDetails}>

                    {this.state.survey?.surveysDetails ?
                        <Container className="d-flex justify-content-center mt-5">
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th scope="col">S No</th>
                                        <th scope="col">User ID</th>
                                        <th scope="col">Survey Name</th>
                                        <th scope="col">Points</th>
                                        <th scope="col">Date & Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">1</th>
                                        <td>{this.state.survey.user.id}</td>
                                        <td>{this.state.survey.surveysDetails.survey.name}</td>
                                        {/*<td>{this.state.survey.surveysDetails.survey.ceggPoints}</td>*/}
                                        <td>{`${this.state.survey.surveysDetails.survey.terminate}${this.state.survey.surveysDetails.survey.pointAllocationType !== 'Auto' ? ' (Pending)' : ''}`}</td>
                                        <td>{formatDate(this.state.survey.updatedAt)}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Container>
                        : null
                    }

                    {this.state.survey?.surveysDetails ?
                        <Container className="d-flex justify-content-center mt-5">
                            <Row>
                                <Col>
                                    <strong>Disclaimer: </strong>
                                    <p dangerouslySetInnerHTML={{
                                        __html: this.state.survey?.surveysDetails.survey.disclaimer || 'NA',
                                    }} />
                                </Col>
                            </Row>
                        </Container>
                        : null
                    }

                    <Container className="d-flex justify-content-center mt-5">
                        <Alert
                            variant="danger"
                            show={this.state.status === PageStatus.Error}
                        >
                            {this.state.error}
                        </Alert>
                    </Container>
                </Show>
            </div>

        );
    }
}

